type DateISO8601 =
  `${number}-${string}-${number}T${number}:${number}:${number}${'.' | ''}${number | ''}${'Z' | `${'+' | '-'}${number}:${number}`}`

type DateOfSale = `${number}-${number}-${number}`
type DateOfSaleFR = `${number}/${number}/${number}`

const defaultDateISO8601: DateISO8601 = '2000-10-20T08:33:56.460Z'
// this format does not work with dayjs
const defaultDateOfSale: DateOfSale = '2000-10-20'
const defaultDateOfSaleFR: DateOfSaleFR = '20/10/2000'

export { defaultDateISO8601, defaultDateOfSale, defaultDateOfSaleFR }
export type { DateISO8601, DateOfSale, DateOfSaleFR }
